import type { FC } from 'react'
import React from 'react'

import { OverallOutcomeStatus, OutcomeStatus } from '@/types/Outcome'

import Pill from './Pill'

type Props = {
  overallOutcomeStatus?: OverallOutcomeStatus
  outcomeStatus: OutcomeStatus
}

const OutcomeStatusPill: FC<Props> = ({ overallOutcomeStatus, outcomeStatus }) => {
  if (outcomeStatus === OutcomeStatus.accepted || outcomeStatus === OutcomeStatus.pass) {
    return <Pill type="positive">Pass</Pill>
  }

  if (outcomeStatus === OutcomeStatus.conditionsMet) {
    return <Pill type="positive">Conditions Met</Pill>
  }

  if (
    outcomeStatus === OutcomeStatus.conditionalPass ||
    ((outcomeStatus === OutcomeStatus.rejected || outcomeStatus === OutcomeStatus.fail) &&
      (overallOutcomeStatus === OverallOutcomeStatus.accepted ||
        overallOutcomeStatus === OverallOutcomeStatus.pass))
  ) {
    return <Pill type="positive">Conditional Pass</Pill>
  }

  if (outcomeStatus === OutcomeStatus.rejected) {
    return <Pill type="negative">Rejected</Pill>
  }

  if (outcomeStatus === OutcomeStatus.reOpened) {
    return <Pill type="info">Re-Opened</Pill>
  }

  if (outcomeStatus === OutcomeStatus.awaitingResponse) {
    return <Pill type="neutral">Awaiting Response</Pill>
  }

  return <Pill type="caution">Needs manual review</Pill>
}

export default OutcomeStatusPill
